import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper.ts";
import type { AgingSummaryState } from "../hooks/useAgingSummaryState.ts";

export const AgingSummaryContext = createContext<AgingSummaryState | undefined>(undefined);

const useAgingSummaryContext = (): AgingSummaryState => {
  const context = defined(
    use(AgingSummaryContext),
    "useAgingSummaryContext must be used within an AgingSummaryContext.Provider"
  );
  return context;
};

export default useAgingSummaryContext;
